import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { UserService } from '@services/user/user.service';
import { LanguageService } from '@services/user/language.service';
import { UserData } from '@models/User/UserData';
import { NgFor } from '@angular/common';
import { Subject, take, takeUntil } from 'rxjs';

@Component({
  selector: 'app-language',
  imports: [MatMenuModule, NgFor],
  templateUrl: './language.component.html',
  styleUrl: './language.component.css',
})
export class LanguageComponent implements OnInit, OnDestroy {
  private destroyed = new Subject<void>();

  @Input() external: boolean = false;

  changeLangs: any[] = [];

  currentFlag: string | undefined;

  constructor(
    public userService: UserService,
    private languageService: LanguageService,
  ) {}

  ngOnInit(): void {
    if (!this.external) {
      this.userService
        .getUserdata()
        .pipe(takeUntil(this.destroyed),take(1))
        .subscribe({
          next: (userdata: any) => {
            this.languageService.setAuthenticated();
            this.changeUiLanguage(userdata.language);
          },
        });
    } else {
      this.changeUiLangFlag(this.languageService.currentLang);
      this.languageService.languageChanged$.pipe(takeUntil(this.destroyed)).subscribe((lang) => {
        this.changeUiLangFlag(lang);
      });
    }
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  changeLanguage(lang: string) {
    const langEnum = this.langEnum(lang);
    if (!this.external) {
      this.userService.updateLanguage(langEnum).subscribe((data) => {
        this.userService.getUserdata(true); // invalida la cache, così il resolver vede la lingua aggiornata
        this.changeUiLanguage(lang);
      });
    } else {
      this.changeUiLanguage(lang);
    }
  }

  private changeUiLanguage(lang: string) {
    const langUi = this.langUi(lang);
    this.languageService.changeLanguage(langUi);
    this.currentFlag = this.languageService.allLangs.find((item) => item.lang === langUi)?.flag;
    this.changeLangs = this.languageService.allLangs.filter((item) => item.lang !== langUi);
  }

  private changeUiLangFlag(lang: string) {
    const langUi = this.langUi(lang);
    this.currentFlag = this.languageService.allLangs.find((item) => item.lang === langUi)?.flag;
    this.changeLangs = this.languageService.allLangs.filter((item) => item.lang !== langUi);
  }

  private langEnum(lang: string): string {
    if (lang === 'italiano') {
      return lang;
    } else if (lang === 'english') {
      return lang;
    } else if (lang === 'deutsch') {
      return lang;
    } else if (lang === 'it') {
      return 'italiano';
    } else if (lang === 'en') {
      return 'english';
    } else if (lang === 'deu') {
      return 'deutsch';
    } else if (lang === 'fr') {
      return 'francaise';
    } else if (lang === 'es'){
      return 'spanish'
    }
    else if (lang === 'spanish'){
      return lang;
    }else {
      //default
      return 'english';
    }
  }

  private langUi(lang: string): string {
    if (lang === 'italiano') {
      return 'it';
    } else if (lang === 'english') {
      return 'en';
    } else if (lang === 'deutsch') {
      return 'deu';
    } else if (lang === 'francaise') {
      return 'fr';
    } if (lang === 'spanish'){
      return "es";
    }
    else if (lang === 'it') {
      return lang;
    } else if (lang === 'en') {
      return lang;
    } else if (lang === 'deu') {
      return lang;
    } else if (lang === 'fr') {
      return lang;
    }else if (lang === 'es') {
      return lang;
    } else {
      //default
      return 'en';
    }
  }
}
